import { render, staticRenderFns } from "./XimuFooter.vue?vue&type=template&id=7ddca8b0&scoped=true"
import script from "./XimuFooter.vue?vue&type=script&lang=js"
export * from "./XimuFooter.vue?vue&type=script&lang=js"
import style0 from "./XimuFooter.vue?vue&type=style&index=0&id=7ddca8b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddca8b0",
  null
  
)

export default component.exports